import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { useSWRFetcher } from "./useSWRFetcher";
import { CommentPartModel } from "../models/EmailActionModels";
import { ToastContext } from "../context/ToastContext";
import { environment } from "../config/environment";

type Options = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useReceivablesAddComment = (externalId: string | null, { onSuccess, onError }: Options = {}) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    externalId ? `${environment.apiUrl}/api/receivables/${externalId}/comments` : undefined,
    (url: string, { arg }: { arg: { comment: CommentPartModel[] } }) =>
      fetcher<{ result: string }>(url, {
        method: "POST",
        body: JSON.stringify(arg),
      }),
    {
      onSuccess: () => {
        onSuccess?.();
      },
      onError: () => {
        showToast("Failed to add comment, please try again later", "error");
        onError?.();
      },
    }
  );

  return {
    addComment: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
